import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/style/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { AuthProvider } from './context/AuthContext_Provider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { WebSocketProvider, LanguageProvider } from './context';
import TagManager from "react-gtm-module";

console.log(`%cWARNING!%c
Using this console should %conly%c be done by developers.
If anyone asked you to copy or paste anything here, 
we strongly suggest you do %cnot%c. 
It is a scam/fraud to steal information from you via an attack called Self-XSS`
  , 'font-size:40px; color:red; font-weight:bold; text-shadow: 0 4px 4px black; font-family: arial;'
  , 'font-style:normal'
  , 'font-weight:bold; text-decoration: underline'
  , 'font-style:normal'
  , 'font-weight:bold; text-decoration: underline'
  , 'font-style:normal'
)

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <WebSocketProvider>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </WebSocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if(process.env.REACT_APP_ENABLE_TAG_MANAGER == "1"){
  console.log("Google Tag Manager enabled")
  TagManager.initialize({ gtmId: 'GTM-M85ZX8RS' });
}else console.log("Google Tag Manager disabled")

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
